export const SCHOOL_ADMIN_QUESTION_POOL_SET_LOADING = `@school-admin-question-pool/set-loading`;
export const SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTION_ACTIVATION_STATE_UPDATING = `@school-admin-question-pool/set-question-activation-state-updationg`;
export const SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTIONS = `@school-admin-question-pool/set-questions`;
export const SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTIONS_QUERY_PARAMS = `@school-admin-question-pool/set-questions-query-params`;

export const SCHOOL_ADMIN_QUESTION_POOL_GET_QUESTIONS = `@school-admin-question-pool/get-questions`;
export const SCHOOL_ADMIN_QUESTION_POOL_SET_QUESTION_ACTIVATION_STATE = `@school-admin-question-pool/set-question-activation-state`;


// WEBPACK FOOTER //
// ./src/actions/school-admin/question-pool/types.js